const env = process.env.REACT_APP_ENV || 'dev'

const apiUrls = {
  dev: 'http://localhost:8080',
  prod: 'https://i-want-to-4b530.uc.r.appspot.com'
}
export const apiUrl = apiUrls[env]
